<template>
  <div class="fade-in">
    <h1 class="title">Edit User</h1>

    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      class="account-form"
    >
      <formly-form :form="form" :model="model" :fields="fields"></formly-form>
      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Update
          </button>
        </div>
        <div class="control">
          <router-link
            :to="{ name: 'user-list', params: { id } }"
            class="button is-link is-small"
            >Cancel
          </router-link>
        </div>
      </div>
    </form>

    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import _ from "lodash";
import VueToastr from "vue-toastr";
import PracticesService from "@/services/PracticesService";
import fields from "@/components/practice/UserFields";

export default {
  name: "practice-user-edit",

  mixins: [fields],

  props: ["id", "userId"],

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      model: {
        id: null,
        practiceId: this.id
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      PracticesService.updateUser(this.model)
        .then(() => {
          this.loading = false;
          this.$router.push({
            name: "user-list",
            params: { id: this.$props.id }
          });
          this.$refs.toastr.s("The user has been updated.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error updating the user.");
        });
    }
  },

  mounted() {
    const user = this.$store.getters["practice/getUser"](this.$props.userId);
    this.model = { ...this.model, ...user.attributes, id: user.id };

    const index = _.findIndex(this.fields, ["key", "password"]);
    this.fields[index].templateOptions.label =
      "Password [leave blank to keep it the same]";
  }
};
</script>

<style lang="scss"></style>
